export const mobileMenuClick = () => {

    const mobileMenuButton = document.querySelector(".mobile-menu__logo-container-close-button")    
    const mainMenuButton = document.querySelector(".header__mobile-menu")
    const mobileMenuWrapper = document.querySelector(".mobile-menu__wrapper")

    mobileMenuButton.addEventListener("click", () => { 
        mobileMenuWrapper.classList.remove("mobile-menu__wrapper-active") 
    })

    mainMenuButton.addEventListener("click", () => { 
        mobileMenuWrapper.classList.add("mobile-menu__wrapper-active")         
    })

    window.addEventListener("resize", () => {
        mobileMenuWrapper.classList.remove("mobile-menu__wrapper-active")
    })
}





